/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BrowserGeolocationPosition } from './BrowserGeolocationPosition';
import type { CommuteType } from './CommuteType';
import type { Resource } from './Resource';
import type { Task } from './Task';
import type { TrackingTaskType } from './TrackingTaskType';
import type { WorkLocation } from './WorkLocation';
export type TimeTrackingStartEventBody = {
    action: TimeTrackingStartEventBody.action;
    start_time: string;
    work_package_id?: string;
    work_location?: WorkLocation;
    resource: Resource;
    tracking_task_type: TrackingTaskType;
    arrival_commute_type: CommuteType;
    departure_commute_type: CommuteType;
    position: (BrowserGeolocationPosition | null);
    construction_site_manager_id: string;
    task?: Task;
    training_note?: string;
};
export namespace TimeTrackingStartEventBody {
    export enum action {
        START = 'start',
    }
}

